import LabelItem from './LabelItem';

export default LabelItem;
